const DOCUMENT = 'INFRACTION_MODAL_';

const actions = {
  ADD_REQUEST: DOCUMENT + 'ADD_REQUEST',
  CHANGE_VALUE: DOCUMENT + 'CHANGE_VALUE',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',

  addRequest: payload => ({ type: actions.ADD_REQUEST, payload }),
  changeValue: payload => ({ type: actions.CHANGE_VALUE, payload }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
  loadFormData: payload => ({ type: actions.LOAD_REQUEST, payload }),
  loadFormDataSuccess: payload => ({ type: actions.LOAD_SUCCESS, payload }),
};

export default actions;
